import { BlockMultimediaContent } from 'store/states/lessons.state'
import api from '../..'

export const getMultimediaBlock = (blockId: number) => {
  return api.get(`block_multimedia/block_instances/${blockId}`).then(
    ({
      data: {
        data: { attributes },
      },
    }): BlockMultimediaContent => {
      const {
        id,
        showTitle,
        url,
        fileData,
        blockInstanceableId,
        lockProgress,
        denyDownload,
        blockInstanceable: {
          name,
          mandatory,
          order,
          description,
          blockInstanceableType,
        },
        resolutions,
      } = attributes
      return {
        id,
        blockInstanceableId,
        name,
        mandatory,
        order,
        description,
        type: blockInstanceableType,
        fileData,
        url,
        showTitle,
        lockProgress,
        denyDownload,
        resolutions,
      }
    }
  )
}
